'use client'

import { Builder, withChildren } from '@builder.io/react'

import { AppLink } from './AppLink'

Builder.registerComponent(withChildren(AppLink), {
  name: 'AppLink',
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Content' } },
    },
  ],
  inputs: [
    {
      name: 'defaultLink',
      friendlyName: 'Default link URL',
      type: 'string',
      defaultValue: '/login-bodweb?locale=en_US',
    },
    {
      name: 'iosLink',
      friendlyName: 'App Store link URL',
      type: 'string',
      defaultValue: 'https://apps.apple.com/us/app/beachbody-on-demand/id1031660123',
    },
    {
      name: 'androidLink',
      friendlyName: 'Play Store link URL',
      type: 'string',
      defaultValue: 'https://play.google.com/store/apps/details?id=com.beachbody.bod',
    },
    {
      name: 'title',
      friendlyName: 'Title',
      type: 'string',
      defaultValue: 'Get the app',
      localized: true,
    },
    {
      name: 'description',
      friendlyName: 'Description',
      type: 'string',
      defaultValue: 'Enjoy BODi on your phone, tablet, TV, bike, or computer!',
      localized: true,
    },
    {
      name: 'buttonText',
      friendlyName: 'Button text',
      type: 'string',
      defaultValue: 'GET STARTED',
      localized: true,
    },
    {
      name: 'className',
      friendlyName: 'Class name',
      type: 'string',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/device-mobile-share.svg',
})
